import { useLocation, useNavigate } from "react-router-dom";
import { MapPin, Phone, Mail, Facebook, Instagram, Youtube, ArrowLeft } from "lucide-react";
import { Link } from "react-router-dom";

const LOGO = "https://assets.wordaliveglobal.org/branding/wagc_logo_small.png";

export default function Layout({ children, hideFooter = false }) {
  const location = useLocation();
  const navigate = useNavigate();

  // Back button: show on drill-down pages (not top-level navigation targets)
  const TOP_LEVEL = ["/", "/live-events", "/collectives", "/media", "/bookstore", "/giving", "/about", "/rental", "/me", "/dash", "/wa-ops-center", "/dashboard", "/den", "/events", "/videos", "/admin", "/auth-callback", "/request-page", "/links"];
  const isTopLevel = TOP_LEVEL.includes(location.pathname);
  const hasOwnBackButton = /^\/collectives\/[^/]+\/room$/.test(location.pathname);
  const showBackButton = !isTopLevel && !hasOwnBackButton;

  return (
    <>
      {showBackButton && (
        <div className="bg-bone border-b border-bone-dark">
          <div className="container-page">
            <button
              data-testid="global-back-button"
              onClick={() => navigate(-1)}
              className="flex items-center gap-1.5 py-2 text-sm text-navy/60 hover:text-gold transition-colors"
            >
              <ArrowLeft className="h-4 w-4" />
              Back
            </button>
          </div>
        </div>
      )}

      {children}

      {!hideFooter && (
        <footer className="hidden md:block bg-navy text-white py-16">
          <div className="container-page">
            <div className="grid grid-cols-1 md:grid-cols-3 gap-12">
              <div>
                <img src={LOGO} alt="WAGC Logo" className="h-14 mb-4 opacity-90" />
                <p className="text-white/60 text-xs leading-relaxed max-w-sm">
                  Word Alive Global Center is a 501(c)(3) 5-fold Christian ministry led by Apostle Dayna Milam, engaging the region for advancement.
                </p>
              </div>
              <div>
                <h3 className="font-heading text-base text-gold mb-3">Contact</h3>
                <div className="flex flex-col gap-2.5 text-xs text-white/60">
                  <span className="flex items-center gap-2"><MapPin className="h-3.5 w-3.5 text-gold shrink-0" /> 1120 W Panola Street, Carthage, TX 75633</span>
                  <span className="flex items-center gap-2"><Phone className="h-3.5 w-3.5 text-gold shrink-0" /> (903) 690-3433</span>
                  <span className="flex items-center gap-2"><Mail className="h-3.5 w-3.5 text-gold shrink-0" /> contactus@wordalivetx.com</span>
                </div>
              </div>
              <div>
                <h3 className="font-heading text-base text-gold mb-3">Connect</h3>
                <div className="flex gap-3 mb-5">
                  <a href="https://www.facebook.com/WordAliveGlobalCenter" target="_blank" rel="noopener noreferrer" data-testid="social-facebook"><Facebook className="h-4 w-4 text-white/60 hover:text-gold transition-colors" /></a>
                  <a href="https://www.instagram.com/wordaliveglobalcenter" target="_blank" rel="noopener noreferrer" data-testid="social-instagram"><Instagram className="h-4 w-4 text-white/60 hover:text-gold transition-colors" /></a>
                  <a href="https://www.youtube.com/@WordAliveGlobalCenter" target="_blank" rel="noopener noreferrer" data-testid="social-youtube"><Youtube className="h-4 w-4 text-white/60 hover:text-gold transition-colors" /></a>
                </div>
                <h3 className="font-heading text-base text-gold mb-2">Quick Links</h3>
                <div className="flex flex-col gap-1.5 text-xs text-white/60">
                  <Link to="/live-events" className="hover:text-gold transition-colors">Events</Link>
                  <Link to="/collectives" className="hover:text-gold transition-colors">Collectives</Link>
                  <Link to="/bookstore" className="hover:text-gold transition-colors">Bookstore</Link>
                  <Link to="/giving" className="hover:text-gold transition-colors">Give</Link>
                  <Link to="/about" className="hover:text-gold transition-colors">About</Link>
                </div>
              </div>
            </div>
            <div className="border-t border-white/10 mt-10 pt-6 flex justify-between items-center text-[10px] uppercase tracking-wider font-semibold text-white/30">
              <span>&copy; {new Date().getFullYear()} Word Alive Global Center. All rights reserved.</span>
            </div>
          </div>
        </footer>
      )}
    </>
  );
}
